import { render } from "./OldBookCartDrawer.vue?vue&type=template&id=312292c0&scoped=true"
import script from "./OldBookCartDrawer.js?vue&type=script&lang=js&external"
export * from "./OldBookCartDrawer.js?vue&type=script&lang=js&external"

import "./OldBookCartDrawer.css?vue&type=style&index=0&id=312292c0&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-312292c0"]])

export default __exports__